"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rtmp = void 0;
var _react = _interopRequireDefault(require("react"));
var Rtmp = exports.Rtmp = function Rtmp() {
  return _react["default"].createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("rect", {
    width: "36",
    height: "36",
    rx: "2",
    fill: "#5C617C"
  }), _react["default"].createElement("path", {
    d: "M25 15C25.5312 15 26 14.5625 26 14V12C26 11.4688 25.5312 11 25 11H11C10.4375 11 10 11.4688 10 12V14C10 14.5625 10.4375 15 11 15H25ZM23.5 12.25C23.9062 12.25 24.25 12.5938 24.25 13C24.25 13.4375 23.9062 13.75 23.5 13.75C23.0625 13.75 22.75 13.4375 22.75 13C22.75 12.5938 23.0625 12.25 23.5 12.25ZM21.5 12.25C21.9062 12.25 22.25 12.5938 22.25 13C22.25 13.4375 21.9062 13.75 21.5 13.75C21.0625 13.75 20.75 13.4375 20.75 13C20.75 12.5938 21.0625 12.25 21.5 12.25ZM25 20C25.5312 20 26 19.5625 26 19V17C26 16.4688 25.5312 16 25 16H11C10.4375 16 10 16.4688 10 17V19C10 19.5625 10.4375 20 11 20H25ZM23.5 17.25C23.9062 17.25 24.25 17.5938 24.25 18C24.25 18.4375 23.9062 18.75 23.5 18.75C23.0625 18.75 22.75 18.4375 22.75 18C22.75 17.5938 23.0625 17.25 23.5 17.25ZM21.5 17.25C21.9062 17.25 22.25 17.5938 22.25 18C22.25 18.4375 21.9062 18.75 21.5 18.75C21.0625 18.75 20.75 18.4375 20.75 18C20.75 17.5938 21.0625 17.25 21.5 17.25ZM25 25C25.5312 25 26 24.5625 26 24V22C26 21.4688 25.5312 21 25 21H11C10.4375 21 10 21.4688 10 22V24C10 24.5625 10.4375 25 11 25H25ZM23.5 22.25C23.9062 22.25 24.25 22.5938 24.25 23C24.25 23.4375 23.9062 23.75 23.5 23.75C23.0625 23.75 22.75 23.4375 22.75 23C22.75 22.5938 23.0625 22.25 23.5 22.25ZM21.5 22.25C21.9062 22.25 22.25 22.5938 22.25 23C22.25 23.4375 21.9062 23.75 21.5 23.75C21.0625 23.75 20.75 23.4375 20.75 23C20.75 22.5938 21.0625 22.25 21.5 22.25Z",
    fill: "white"
  }));
};